import posthog from 'posthog-js';

import { isProduction, posthogKey, posthogHost } from '@dashboard/services/env';
import stripUrlsFromEvent from '@dashboard/lib/stripUrlsFromEvent';

if (posthogKey && isProduction) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    cross_subdomain_cookie: true,
    capture_pageview: false,
    autocapture: false,
    capture_pageleave: true,
    // Dashboard pages show buyer names and emails as plain text, so replay masks every text node.
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '*',
    },
    before_send: stripUrlsFromEvent,
  });
}
